import { Datagrid, List, TextField } from 'react-admin';

const EventList = () => {
    return (
        <List sort={{ field: 'createdAt', order: '-1' }}>
            <Datagrid bulkActionButtons={false} rowClick="edit">
                <TextField source="name" />
                <TextField source="status" />
            </Datagrid>
        </List>
    );
};

export default EventList;
